import { createContext, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { MatchParam } from "src/constants/matches";
import { useAnswers } from "../AnswersProvider";

export const AnswerContext = createContext<{
  answers: string[];
  details?: string;
  setDetails: React.Dispatch<React.SetStateAction<string | undefined>>;
  setAnswers: React.Dispatch<React.SetStateAction<string[]>>;
}>({
  answers: [],
  details: undefined,
  setDetails: () => {},
  setAnswers: () => {},
});

interface Props {
  children: React.ReactNode;
}

const AnswerProvider = ({ children }: Props) => {
  const { questionId } = useParams<MatchParam<"QUESTION_ID">>();
  const allAnswers = useAnswers();
  const [answers, setAnswers] = useState<string[]>([]);
  const [details, setDetails] = useState<string | undefined>(undefined);

  const value = useMemo(
    () => ({
      answers,
      details,
      setDetails,
      setAnswers,
    }),
    [answers, details]
  );

  useEffect(() => {
    if (questionId != null) {
      const answer = allAnswers.find((a) => a.question_id === questionId);
      setDetails(answer?.response?.details);
      setAnswers(answer?.response?.answer ?? []);
    }
  }, [allAnswers, questionId]);

  return (
    <AnswerContext.Provider value={value}>{children}</AnswerContext.Provider>
  );
};

export default AnswerProvider;
